import { Box, Paper, styled, Typography } from '@mui/material'

export const Wrapper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '.8rem',
  maxWidth: '100%',
}))

export const Title = styled(Typography)(() => ({}))

Title.defaultProps = {
  variant: 'h4',
}

export const Subtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}))

Subtitle.defaultProps = {
  variant: 'h6',
}

export const FormWrapper = styled(Box)(({ theme }) => ({
  padding: [theme.spacing(4), 0].join(' '),
}))
